<div class="modal">
  <img class="icon" src="assets/img/msg-warning.svg">
  <h4 class="title" translate>
    i18n.dialog.deletePlaceholder.title
  </h4>

  <mat-dialog-content>
    <div class="content" translate>i18n.dialog.deletePlaceholder.message</div>
  </mat-dialog-content>

  <dialog-buttons [buttons]="buttons"></dialog-buttons>
</div>



// WEBPACK FOOTER //
// ./src/app/dialogs/delete-placeholder-dialog/delete-placeholder-dialog.component.html